module.exports = __webpack_public_path__ + "img/z (22).39adee4f.png";